/* tslint:disable */
/* eslint-disable */
/**
 * Survey API
 * API for managing Surveys and Questions.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateSurveyCommandDto
 */
export interface UpdateSurveyCommandDto {
    /**
     * Survey name
     * @type {string}
     * @memberof UpdateSurveyCommandDto
     */
    name: string;
    /**
     * Context ID for the survey
     * @type {string}
     * @memberof UpdateSurveyCommandDto
     */
    contextId: string;
    /**
     * Optional branch ID
     * @type {string}
     * @memberof UpdateSurveyCommandDto
     */
    branchId?: string | null;
    /**
     * Optional survey description
     * @type {string}
     * @memberof UpdateSurveyCommandDto
     */
    description?: string | null;
    /**
     * Whether the survey is active
     * @type {boolean}
     * @memberof UpdateSurveyCommandDto
     */
    isActive?: boolean;
}

/**
 * Check if a given object implements the UpdateSurveyCommandDto interface.
 */
export function instanceOfUpdateSurveyCommandDto(value: object): value is UpdateSurveyCommandDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('contextId' in value) || value['contextId'] === undefined) return false;
    return true;
}

export function UpdateSurveyCommandDtoFromJSON(json: any): UpdateSurveyCommandDto {
    return UpdateSurveyCommandDtoFromJSONTyped(json, false);
}

export function UpdateSurveyCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateSurveyCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'contextId': json['contextId'],
        'branchId': json['branchId'] == null ? undefined : json['branchId'],
        'description': json['description'] == null ? undefined : json['description'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
    };
}

export function UpdateSurveyCommandDtoToJSON(json: any): UpdateSurveyCommandDto {
    return UpdateSurveyCommandDtoToJSONTyped(json, false);
}

export function UpdateSurveyCommandDtoToJSONTyped(value?: UpdateSurveyCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'contextId': value['contextId'],
        'branchId': value['branchId'],
        'description': value['description'],
        'isActive': value['isActive'],
    };
}

